import { anchorProduct } from "../../store/actionCreators";
import { getLocation } from "../../../../router/selectors";
import { updateLocationQuery } from "../../../../router/actions";
import { CAROUSEL_ID } from "../../../../../../components/UpSellCarousel/constants";

export const anchorProductToUrl =
  ({ productTileId, carouselCatId }) =>
  (dispatch, getState) => {
    dispatch(anchorProduct());

    const { query } = getLocation(getState());

    dispatch(
      updateLocationQuery({
        query: {
          ...query,
          scrollTo: carouselCatId ? CAROUSEL_ID : productTileId,
        },
      }),
    );
  };
